import React, { useState } from 'react';
import { Box } from '@components/Box';
import {
  BlogCenterTextPairing,
  SliderContainer,
  SlideBackgroundImage,
  StyledMobileSection,
  StyledBox,
  RiskFreeReservationsWrapper,
} from './RiskFreeReservationsSection.styles';
import ReactHtmlParser from 'react-html-parser';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { defaultBase64Placeholder } from '@components/CloudImage';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';
import { useTranslation } from 'react-i18next';
import { JoykitColor } from '@components/themes';

export const RiskFreeReservationsSection: React.FC = () => {
  let [isScrolledIntoView, setScrolledIntoView] = useState(false);
  const { t } = useTranslation('hotelRoomBlocks');
  const riskFreeReservationData = t('riskFreeReservationsSection');
  const slideBackground = riskFreeReservationData.slide;

  return (
    <StyledMobileSection as="section" id="Risk_Free_Reservations_Section" marginTop={'5rem'}>
      <SliderContainer id="SliderContainer">
        <SlideBackgroundImage
          id={`slideBackground`}
          className="slideActive slideImg"
          backgroundColor={slideBackground.bgColor}
          backgroundImage={isScrolledIntoView ? slideBackground.bgImage : defaultBase64Placeholder}
          backgroundImageMobile={isScrolledIntoView ? slideBackground.bgImageMobile : defaultBase64Placeholder}
        >
          <LazyLoadWrapper beforeLoad={() => setScrolledIntoView(true)}>
            <div />
          </LazyLoadWrapper>
          <RiskFreeReservationsWrapper flexDirection="column" alignItems="center">
            <StyledBox alignItems="center">
              <BlogCenterTextPairing
                alignment="center"
                eyebrow={riskFreeReservationData.eyebrow}
                eyebrowColor={slideBackground.eyebrowColor as JoykitColor}
                eyebrowVariant="sectionEyeBrow24"
                eyebrowTagName="h2"
                title={ReactHtmlParser(riskFreeReservationData.title)}
                titleVariant="hed40"
                titleColor={slideBackground.titleColor as JoykitColor}
                titleTagName="h2"
                body={riskFreeReservationData.body}
                bodyVariant="dek24"
                bodyColor={slideBackground.bodyColor as JoykitColor}
                bodyTagName="p"
              />
            </StyledBox>
            <Box style={{ textAlign: 'center', position: 'relative', zIndex: 2 }} marginTop={[8, 8]}>
              <GetStartedButton id={`riskFreeReservationsSection`} page={'hotel-room-blocks'} variant="primary">
                {riskFreeReservationData.buttonStarted}
              </GetStartedButton>
            </Box>
          </RiskFreeReservationsWrapper>
        </SlideBackgroundImage>
      </SliderContainer>
    </StyledMobileSection>
  );
};
